<template>
  <div>
    <input ref="upload" style="display: none" type="file" @change="onUpload" />
    <Pane />
    <a-card class="container">
      <a-form-model layout="inline" :colon="false" :model="form" @keyup.enter.native="query">
        <a-row>
          <a-col :span="24">



            <a-form-model-item>
              <a-input placeholder="设计编号" v-model="form.code" style="width: 150px" list="codeList">
              </a-input>
              <datalist id="codeList">
                <option v-for="item in codeList" :key="item">
                  {{ item }}
                </option>
              </datalist>
            </a-form-model-item>

            <a-form-model-item>
              <a-input placeholder="合同名称" v-model="form.name" style="width: 150px"></a-input>
            </a-form-model-item>

            <a-form-model-item>
              <a-input placeholder="生产负责人" v-model="form.productionMasterName" style="width: 150px"></a-input>
            </a-form-model-item>

            <a-form-model-item>
              <a-select
                  placeholder="生产部门"
                  show-search
                  :filter-option="$selectFilterOption"
                  v-model="form.oriProductionUnitId"
                  style="width: 150px"
              >
                <a-select-option
                    v-for="item in productionDepartmentList"
                    :key="item.id"
                    :value="item.id"
                >
                  {{
                    item.uniqueName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item>
              <a-select
                  placeholder="责任部门"
                  show-search
                  :filter-option="$selectFilterOption"
                  v-model="form.productionUnitId"
                  style="width: 150px"
              >
                <a-select-option
                    v-for="item in productionDepartmentList"
                    :key="item.id"
                    :value="item.id"
                >
                  {{
                    item.uniqueName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-select
                  placeholder="合同项目状态"
                  allow-clear
                  v-model="form.conProjectStatus"
                  style="width: 150px"
              >
                <a-select-option
                    v-for="item in statusList"
                    :key="item.value"
                    :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
            <a-button  type="primary" style="float: right;margin-top: 5px;" @click="onClick">导入分院进度</a-button>
            <a-button v-if="isContractAssets" type="primary" style="float: right;margin-top: 5px;margin-right: 10px;" @click="onExport">导出合同资产</a-button>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding />

      <a-table bordered :data-source="list" :loading="loading" @change="onChange" :pagination="{
        total,
        current,
        pageSize,
        showTotal: (total) => `共 ${total} 条记录`,
      }" rowKey="id">
        <a-table-column title="设计编号" width="120px" fixed="left" data-index="code" />
        <a-table-column title="部门">
          <template slot-scope="text">
            <span>
              {{ text.productionUnitName }}
            </span>
          </template>
        </a-table-column>
        <a-table-column title="合同名称">
          <template slot-scope="text">
            <span>
              {{ text.name }}
            </span>
          </template>
        </a-table-column>

        <a-table-column title="合同金额(万)" align="right">
          <template slot-scope="text">
            <Money :money="text.contractAmountSum" />
          </template>
        </a-table-column>

        <a-table-column title="分包数量" width="80px" align="right">
          <template slot-scope="text">
            <a-popover placement="bottomRight">
              <template slot="content">
                <a-table size="small" bordered :data-source="Array.isArray(text.subList) ? text.subList : []"
                         :pagination="false" rowKey="id">
                  <a-table-column title="分包名" data-index="name" />
                  <a-table-column title="分包属性">
                    <template slot-scope="text">
                      <span v-if="text.isneeded === 1">设计类-必要分包</span>
                      <span v-if="text.isneeded === 0">设计类-非必要分包</span>
                      <span v-if="text.isneeded === 2">总承包类分包</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="分包类别">
                    <template slot-scope="text">
                      <DataDictFinder dictType="subType" :dictValue="text.type" />
                      <DataDictFinder dictType="notNeedSubType" :dictValue="text.type" />
                      <DataDictFinder dictType="generalSubType" :dictValue="text.type" />
                    </template>
                  </a-table-column>

                  <a-table-column title="分包方" data-index="companyName" />
                  <a-table-column title="分包状态" align="center">
                    <template slot-scope="text">
                      <DataDictFinder dictType="subpackageStatus" :dictValue="text.status" iconType="text" />
                    </template>
                  </a-table-column>
                  <a-table-column title="已支付金额(万)" align="right">
                    <template slot-scope="text">
                      <Money :money="text.paymentAmount" />
                    </template>
                  </a-table-column>
                  <a-table-column title="预算金额(万)" align="right">
                    <template slot-scope="text">
                      <Money :money="text.planAmount" />
                    </template>
                  </a-table-column>
                </a-table>
              </template>
              <span style="color: #1890ff">
                {{ text.subCount }}
                <a-icon type="down-circle" />
              </span>
            </a-popover>
          </template>
        </a-table-column>
        <a-table-column title="累计确认比例" width="100px" align="right">
          <template slot-scope="text"> {{ text.progress }}% </template>
        </a-table-column>
        <a-table-column title="累计进度金额(万元)" width="100px" align="right">
          <template slot-scope="text"> {{ text.progressAmount }} </template>
        </a-table-column>
        <a-table-column title="可开票比例" width="100px" align="right">
          <template slot-scope="text"> {{ text.receiptRatio }}% </template>
        </a-table-column>
        <a-table-column title="可开票金额(万元)" width="100px" align="right">
          <template slot-scope="text"> {{ text.receiptAmount }} </template>
        </a-table-column>
        <a-table-column title="开票金额(万元)" width="100px" align="right">
          <template slot-scope="text">
            <a-popover placement="bottomRight">
              <template slot="content">
                <a-table size="small" bordered :data-source="Array.isArray(text.invoiceList) ? text.invoiceList : []
                  " :pagination="false" rowKey="id">
                  <a-table-column title="发票号码" data-index="invoiceCode" />
                  <a-table-column title="业务内容" data-index="business" />
                  <a-table-column title="开票日期" data-index="invoiceDate" align="center" />
                  <a-table-column title="发票金额(元)" align="right">
                    <template slot-scope="text">
                      <span v-if="parseFloat(text.totalPriceLowercase) < 0" style="color: #f00">{{
                          parseFloat(text.totalPriceLowercase).toLocaleString()
                        }}</span>
                      <span v-else style="color: #1890ff">{{
                          parseFloat(text.totalPriceLowercase).toLocaleString()
                        }}</span>
                    </template>
                  </a-table-column>

                </a-table>
              </template>

              <span :style="{ color: text.invoiceSum >= 0 ? '#1890ff' : '#f00' }">
                {{text.conInvoiceSum}}
                <a-icon type="down-circle" style="margin-left: 4px" />
              </span>
            </a-popover>
          </template>
        </a-table-column>
        <a-table-column title="回款金额(万元)" width="100px" align="right">
          <template slot-scope="text">
            <a-popover placement="bottomRight">
              <template slot="content">
                <a-table size="small" bordered :data-source="Array.isArray(text.conPaymentList) ? text.conPaymentList : []
                  " :pagination="false" rowKey="id">
                  <a-table-column title="回款日期" data-index="date" align="center" />
                  <a-table-column title="回款金额(元)" align="right">
                    <template slot-scope="text">
                      <span v-if="parseFloat(text.amount) < 0" style="color: #f00">{{
                          parseFloat(text.amount).toLocaleString()
                        }}</span>
                      <span v-else style="color: #1890ff">{{
                          parseFloat(text.amount).toLocaleString()
                        }}</span>
                    </template>
                  </a-table-column>
                </a-table>
              </template>

              <span :style="{ color: text.invoiceSum >= 0 ? '#1890ff' : '#f00' }">
                {{text.conPaymentSum}}
                <a-icon type="down-circle" style="margin-left: 4px" />
              </span>
            </a-popover>
          </template>
        </a-table-column>

        <a-table-column title="合同项目状态" width="150px" align="center">
          <template slot-scope="text">
            <div style="display:flex;justify-content: center;align-items: center">
              <DataDictFinder dictType="con_prj_status" :dictValue="text.conProjectStatus" style="margin-right: 10px" />
              <DataDictFinder dictType="con_prj_status.adjust_contract" :dictValue="text.conProjectStatusSub" />
              <DataDictFinder dictType="con_prj_status.risk_contract" :dictValue="text.conProjectStatusSub" />
            </div>
          </template>
        </a-table-column>

        <a-table-column align="center" width="80px" fixed="right" title="操作">
          <template slot-scope="text">
            <a v-if="$getPermission('/produce/overview/detail')" @click.prevent="
              $router.push('/produce/progress/contractStatus/detail?id=' + text.id)
              " href="#" style="margin-right: 10px">查看</a>
            <a v-if="$getPermission('/produce/overview/edit')" @click.prevent="
              $router.push('/produce/progress/contractStatus/edit?id=' + text.id)
              " href="#">编辑</a>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import { fetchListContract as fetchList } from "@/api/project/overview";
import organization from "@/mixins/organization";
import download from '@/api/download'
import { saveAs } from "file-saver";
import request from "@/api/request";
import axios from 'axios'
import { mapState, mapGetters } from "vuex";



const instance = axios.create({
  responseType: 'blob',
})
function importChangeList(data) {
  return instance({
    url: "/project-service/contract/executionStatus/import",
    method: 'post',
    headers: {
      token: window.localStorage.getItem('token')
    },
    data,
  });
}

function exportContractAssets(data) {
  return instance({
    url: "/project-service/contract/executionStatus/export",
    method: 'post',
    headers: {
      token: window.localStorage.getItem('token')
    },
    data,
  });
}

export default {
  name: "contractStatusOverview",

  mixins: [watermark,organization],

  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("setting", ["findDataDict"]),
    statusList() {
      return this.findDataDict("con_prj_status");
    },
    // 检查是否是合同资产管理员角色
    isContractAssets() {
      if (Array.isArray(this.user.roles)) {
        const index = this.user.roles.findIndex(
            (item) => item.code === "prj_contract_assets"
        );
        return index > -1;
      } else {
        return false;
      }
    },
  },

  data() {
    return {
      form: {},
      codeList: [],

      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      dialog: false,
    };
  },

  watch: {
    $route() {
      console.log(this.$route.query);
      const { keyWord } = this.$route.query;
      if (keyWord) {
        this.form = {
          keyWord,
        };
        console.log('watch: this.form', this.form)
        this.getList();
      }
    },
  },

  mounted() {
    const { query } = this.$route;
    const { keyWord } = query || {};
    console.log('keyWord', keyWord)
    if (keyWord) {
      this.form = {
        keyWord,
      };
    }
    const str = window.localStorage.getItem("search-design-code");
    if (str) {
      this.codeList = JSON.parse(str);
    }

    console.log('activated this.form', this.form)
    this.getList();
  },

  methods: {
    onClick(){
      this.$refs.upload.click();
    },

    onExport() {
      this.loading = true;
      exportContractAssets(this.form)
          .then((res) => {
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', '合同资产.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          })
          .finally(() => {
            this.loading = false;
          });
    },

    onUpload(e) {
      console.log(e)
      const files = e.target.files;
      const data = new FormData();
      for (let i = 0; i < files.length; i++) {
        data.append("file", files[i]);
      }

      this.loading = true;

      importChangeList(data)
          .then((res) => {

            const link = document.createElement('a'); // 创建元素
            let blob = new Blob([res.data]);
            link.style.display='none';
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download',files[0].name) // 为下载后的文件命名
            document.body.appendChild(link)
            link.click(); // 点击下载
            document.body.removeChild(link) // 下载完成后移除元素
            window.URL.revokeObjectURL(link.href) // 释放blob对象
          })
          .finally(() => {
            this.loading = false;
            e.target.value = null;
            this.getList();
          });
    },

    getList() {
      this.saveCode();
      const { current, pageSize } = this;
      this.loading = true;

      console.log('getlist this.form', this.form)


      fetchList({
        pageNum: current,
        pageSize: pageSize,
        ...this.form,
      })
          .then((res) => {
            if (Array.isArray(res.list)) {
              this.list = Object.freeze(res.list);

              this.total = res.totalSize ? res.totalSize : 0;
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },

    saveCode() {
      if (this.form.code) {
        if (this.codeList.indexOf(this.form.code) === -1) {
          this.codeList.unshift(this.form.code);
          if (this.codeList.length > 10) {
            this.codeList.pop();
          }
          window.localStorage.setItem(
              "search-design-code",
              JSON.stringify(this.codeList)
          );
        }
      }
    },
  },
};
</script>
